// extracted by mini-css-extract-plugin
export default {"internalNumberWrapper":"styles_internalNumberWrapper__sK8tM","internalNUmberLink":"styles_internalNUmberLink__LuFXd","questionMark":"styles_questionMark__9vocM"};